import {AnalysisModule} from './analysis/analysis.module';
import {AppComponent} from './app.component';
import {BrowserModule} from '@angular/platform-browser';
import {HsSensorsModule} from 'hslayers-sensors';
import {HslayersModule} from 'hslayers-ng';
import {NgModule} from '@angular/core';

@NgModule({
  imports: [BrowserModule, HslayersModule, AnalysisModule, HsSensorsModule],
  declarations: [AppComponent],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
